import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

//@ts-ignore
import translationEN from "./locales/en/translation.json";
//@ts-ignore
import translationAR from "./locales/ar/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n.use(Backend).use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  debug: false,
});

export default i18n;
